import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Form, Input, message } from 'antd'
import _ from 'lodash'

import * as actions from './ProfilePageActions'
import './ProfilePage.scss'

const FormItem = Form.Item

export class ProfilePage extends Component {
    constructor(props) {
        super(props)

        this.handleSubmit = this.handleSubmit.bind(this)
    }

    checkConfirmPassword(rule, value, callback) {
        const { form } = this.props

        if (value && value !== form.getFieldValue('new_password')) {
            callback('Two passwords are not the same.')
        } else {
            callback()
        }
    }

    handleSubmit(e) {
        e.preventDefault()
        const { token, form, updateProfile } = this.props

        form.validateFields((err, values) => {
            if (!err) {
                updateProfile(token, values, (success, msg) => {
                	if (success)
                		message.success('Profile successfully updated.')
                	else
                		message.error(`Failed to update profile. ${msg}`)
                })
            }
        })
    }

    componentDidMount() {
        const { fetchProfile, token, form } = this.props

        fetchProfile(token, (profile) => {
            const { first_name, last_name, email } = profile
            form.setFieldsValue({ first_name, last_name, email })
        })
    }

    render() {
        const { form, profile } = this.props
        const { username, user_type } = profile

        const { getFieldDecorator } = form
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        }

        return (
            <div className="ProfilePage">
	        	<Form onSubmit={this.handleSubmit}>
	                <FormItem
	                    {...formItemLayout}
	                    label="Username"
	                >
	                	{username}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="User Type"
	                >
	                	{_.startCase(user_type)}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="First Name"
	                >
                        {getFieldDecorator('first_name', {
                            rules: [
                                { required: true, message: 'Please input user first name.' },
                            ],
                            validateTrigger: 'onBlur'
                        })(
                            <Input/>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="Last Name"
	                >
                        {getFieldDecorator('last_name', {})(
                            <Input/>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="Email"
	                >
                        {getFieldDecorator('email', {
                            rules: [
                            	{ type: 'email', message: 'This is not a valid E-mail.' },
                                { required: true, message: 'Please input user email.' },
                            ],
                            validateTrigger: 'onBlur'
                        })(
                            <Input/>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="Current Password"
	                >
                        {getFieldDecorator('password', {
                            rules: [
                                { required: true, message: 'Please input user password.' },
                            ],
                            validateTrigger: 'onBlur'
                        })(
                            <Input type="password"/>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="New Password"
	                >
                        {getFieldDecorator('new_password')(
                            <Input type="password"/>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="Confirm New Password"
	                >
                        {getFieldDecorator('confirm_new_password', {
                            rules: [
                                { required: !_.isEmpty(form.getFieldValue('new_password')), message: 'Please input user new password again.' },
                                { validator: this.checkConfirmPassword.bind(this) }
                            ],
                            validateTrigger: 'onBlur'
                        })(
                            <Input type="password"/>
                        )}
	                </FormItem>
	                <Button type="primary" htmlType="submit" size="large">Update</Button>
	            </Form>
			</div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        profile: state.profilePage.profile
    }
}

const WrappedProfilePage = Form.create()(ProfilePage)

export default connect(mapStateToProps, actions)(WrappedProfilePage)


// WEBPACK FOOTER //
// ./src/ProfilePage/ProfilePage.js